import Cookies from "js-cookie";
import { getCrossPortalParentCookieDomain } from "./domainUtils";
import { ONE_YEAR_IN_MS } from "@constants/common";

/**
 * Returns Cookie options which sets the cookie scope to support cross portal
 * configuration access.
 * - The cookie domain will be set to `.workspaces-web.com` or
 * `.workspaces-web-fips.com` when cross domain capability is available. If
 * custom domain is in use, this is default to DEFAULT_PORTAL_COOKIE_OPTIONS.
 * - default expiration of 365 days
 * - Cookie is secure
 * - sameSite is configured to be strict.
 */
export const getDefaultCrossPortalCookieOptions = (): Cookies.CookieAttributes => ({
    domain: getCrossPortalParentCookieDomain(),
    expires: new Date(Date.now() + ONE_YEAR_IN_MS),
    secure: true,
    sameSite: "strict",
    path: "/",
});
